import { GESTION_OPERATIVA_SELECT_TIPO_TITULARIDAD } from './constants'
const TIPO_COTITULAR = 'cotitularidad'

export function selectTipoTitularidad(tipoTitularidad) {
  return {
    type: GESTION_OPERATIVA_SELECT_TIPO_TITULARIDAD,
    data: { tipoTitularidad },
  }
}

export function reducer(state, action) {
  if (action.type === GESTION_OPERATIVA_SELECT_TIPO_TITULARIDAD) {
      const tipoTitularidad = action.data.tipoTitularidad
      return {
        ...state,
        tipoTitularidad: action.data.tipoTitularidad,
        cotitular: tipoTitularidad === TIPO_COTITULAR ? state.cotitular : null,
      }
  }
  else{
    return state
  }     
}
